import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ArticuloHistorial, ArticuloHistorialTipo } from "@/shared/types/articulo-historial";

export interface ArticuloHistorialesQuery extends BaseQuery {
    desde?:string,
    hasta?:string,
    tipo?:ArticuloHistorialTipo
}

export async function getAllArticuloHistoriales(id:string, query: ArticuloHistorialesQuery = {}): Promise<QueryResponse<ArticuloHistorial>> {
    await sleep(1000);
    const response = await api.get("articulos/" + id + "/historial", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllArticuloHistorialesQuery(id:string, query: ArticuloHistorialesQuery = {}, queryConfig: QueryConfig<QueryResponse<ArticuloHistorial>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllArticuloHistoriales(id, query),
        queryKey: ["articulos", id, "historial", query],
    })
}

export interface GetAllArticuloHistorialesQueryProps{
    id:string,
    query?:ArticuloHistorialesQuery,
    queryConfig?: QueryConfig<QueryResponse<ArticuloHistorial>>,
    children:(queryResult:QueryResult<QueryResponse<ArticuloHistorial>>)=>ReactNode
}

export function GetAllArticuloHistorialesQuery({
    id,
    query,
    queryConfig,
    children
}:GetAllArticuloHistorialesQueryProps){
    const queryResult = useGetAllArticuloHistorialesQuery(id, query, queryConfig);
    return children&&children(queryResult);
}